import Text from '@/components/Text';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { JsonLd } from '@/utils/seo';

const faqs = [
  {
    question: 'What file formats can I upload?',
    answer:
      'STEP, STP, ZIP for 3D models, also DXF or PDF for 2D technical drawings. Drag a file in, to see the full flow.',
  },
  {
    question: 'How is the price calculated?',
    answer:
      "The quote uses your own material costs, machine rates and margins, so it reflects your shop's pricing logic rather than an industry average. Your estimator reviews every quote before it goes out.",
  },
  {
    question: 'Is my CAD file kept private?',
    answer:
      'Yes. Your drawings are strictly isolated to your private workspace. Only you have access to them, and you can permanently delete them at any time.',
  },
  {
    question: 'How secure is our Intellectual Property?',
    answer:
      'Files are encrypted in transit, stored securely for quoting and support purposes, and never used to train public AI models. Mutual NDA available upon request.',
  },
  {
    question: 'How accurate are the instant estimates?',
    answer:
      "Accuracy tracks how closely your material catalog, machine rates and margins are configured, most shops see estimates land within a few percent of their manually-priced quotes, and every quote is reviewable before it's sent.",
  },
  {
    question: 'Can MindPal build a quoting tool for our shop?',
    answer:
      "Yes, this instant-quote flow is a preview of what we configure around your shop's own materials, machines and business rules during a short pilot.",
  },
  {
    question: 'How long does a project like this take?',
    answer:
      'A working configuration typically takes an afternoon with your estimator, with refinements happening as real RFQs come through during the pilot.',
  },
];

const CncRfqFaq = () => {
  return (
    <div className="flex w-full flex-col gap-11">
      <JsonLd
        key="CncRfqFAQPage"
        data={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map(({ question, answer }) => ({
            '@type': 'Question',
            name: question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: answer,
            },
          })),
        }}
      />
      <div className="flex flex-col items-center gap-5 text-center">
        <Text variant="display-4" className="text-center text-jb-neutral-900">
          Frequently Asked Questions
        </Text>
        <Text className="max-w-[511px] text-center text-jb-neutral-800">
          Find answers to common questions about our smart tool and how MindPal
          can help your business.
        </Text>
      </div>
      <Accordion type="single" collapsible className="flex flex-col gap-4">
        {faqs.map(({ question, answer }) => (
          <AccordionItem
            key={question}
            value={question}
            className="rounded-2xl border-none bg-jb-neutral-100 px-6 shadow-review-card"
          >
            <AccordionTrigger className="text-left text-jb-h5 font-semibold text-jb-neutral-900 hover:no-underline">
              {question}
            </AccordionTrigger>
            <AccordionContent className="text-jb-neutral-800">
              {answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default CncRfqFaq;
